const icons: MaterialIconConfig[] = [];

export interface MaterialIconConfig {
  name: string;
  variants: ('filled' | 'outlined' | 'rounded' | 'sharp' | 'two-tone')[];
}

const MATERIAL_ICONS = [
  'home', 'search', 'favorite', 'settings', 'account_circle', 'shopping_cart',
  'delete', 'add', 'check', 'close', 'arrow_back', 'arrow_forward',
  'menu', 'more_vert', 'more_horiz', 'edit', 'visibility', 'visibility_off',
  'lock', 'lock_open', 'mail', 'phone', 'location_on', 'calendar_today',
  'access_time', 'star', 'star_border', 'star_half', 'person', 'group',
  'notifications', 'notifications_active', 'notifications_none', 'help',
  'help_outline', 'info', 'info_outline', 'warning', 'error', 'error_outline',
  'check_circle', 'check_circle_outline', 'cancel', 'add_circle', 'add_circle_outline',
  'remove_circle', 'remove_circle_outline', 'download', 'upload', 'share',
  'print', 'save', 'file_copy', 'folder', 'folder_open', 'attach_file',
  'cloud', 'cloud_upload', 'cloud_download', 'cloud_done', 'refresh', 'sync',
  'done', 'done_all', 'thumb_up', 'thumb_down', 'favorite_border', 'sentiment_satisfied',
  'sentiment_dissatisfied', 'mood', 'mood_bad', 'grade', 'bookmark', 'bookmark_border',
  'book', 'library_books', 'dashboard', 'trending_up', 'trending_down', 'assessment',
  'bar_chart', 'pie_chart', 'show_chart', 'insert_chart', 'table_chart', 'timeline',
  'work', 'work_outline', 'business', 'business_center', 'store', 'storefront',
  'shopping_bag', 'shopping_basket', 'local_shipping', 'local_offer', 'redeem',
  'card_giftcard', 'loyalty', 'payment', 'credit_card', 'attach_money', 'euro',
  'currency_pound', 'currency_yen', 'account_balance', 'account_balance_wallet',
  'receipt', 'receipt_long', 'description', 'assignment', 'assignment_turned_in',
  'article', 'note', 'notes', 'text_snippet', 'subject', 'list', 'list_alt',
  'format_list_bulleted', 'format_list_numbered', 'format_align_left', 'format_align_center',
  'format_align_right', 'format_align_justify', 'format_bold', 'format_italic',
  'format_underlined', 'format_color_text', 'format_size', 'format_quote', 'insert_link',
  'insert_photo', 'insert_emoticon', 'grid_on', 'grid_off', 'view_list', 'view_module',
  'view_quilt', 'view_column', 'view_carousel', 'view_agenda', 'view_array', 'photo',
  'photo_library', 'photo_camera', 'image', 'camera', 'camera_alt', 'video_library',
  'videocam', 'movie', 'play_arrow', 'play_circle', 'play_circle_outline', 'pause',
  'pause_circle', 'stop', 'skip_next', 'skip_previous', 'fast_forward', 'fast_rewind',
  'volume_up', 'volume_down', 'volume_off', 'volume_mute', 'mic', 'mic_off',
  'headset', 'headset_mic', 'speaker', 'laptop', 'computer', 'tablet', 'phone_iphone',
  'phone_android', 'desktop_windows', 'keyboard', 'mouse', 'tv', 'watch', 'devices',
  'speaker_phone', 'router', 'wifi', 'bluetooth', 'gps_fixed', 'gps_not_fixed',
  'location_searching', 'my_location', 'map', 'directions', 'directions_car', 'directions_bike',
  'directions_walk', 'directions_run', 'train', 'flight', 'flight_takeoff', 'flight_land',
  'hotel', 'restaurant', 'local_cafe', 'local_bar', 'local_pizza', 'local_hospital',
  'local_pharmacy', 'fitness_center', 'spa', 'beach_access', 'golf_course', 'casino',
  'theaters', 'museum', 'park', 'nature', 'nature_people', 'landscape', 'filter_hdr',
  'wb_sunny', 'wb_cloudy', 'brightness_high', 'brightness_low', 'brightness_medium',
  'dark_mode', 'light_mode', 'color_lens', 'palette', 'brush', 'draw', 'create',
  'style', 'border_color', 'format_paint', 'straighten', 'crop', 'crop_square',
  'rotate_left', 'rotate_right', 'flip', 'transform', 'tune', 'filter', 'filter_list',
  'sort', 'swap_vert', 'swap_horiz', 'compare_arrows', 'unfold_more', 'unfold_less',
  'expand_more', 'expand_less', 'chevron_left', 'chevron_right', 'first_page', 'last_page',
  'arrow_upward', 'arrow_downward', 'arrow_left', 'arrow_right', 'arrow_drop_down',
  'arrow_drop_up', 'launch', 'open_in_new', 'exit_to_app', 'input', 'power_settings_new',
  'build', 'construction', 'extension', 'puzzle', 'apps', 'widgets', 'category',
  'label', 'label_outline', 'turned_in', 'turned_in_not', 'sell', 'new_releases',
  'verified', 'verified_user', 'security', 'https', 'vpn_key', 'fingerprint',
  'account_box', 'badge', 'contact_mail', 'contact_phone', 'contacts', 'recent_actors',
  'supervisor_account', 'support_agent', 'live_help', 'forum', 'chat', 'chat_bubble',
  'message', 'sms', 'textsms', 'comment', 'feedback', 'announcement', 'campaign',
  'alarm', 'alarm_on', 'alarm_off', 'event', 'event_available', 'event_note',
  'schedule', 'today', 'date_range', 'access_alarm', 'hourglass_empty', 'hourglass_full',
  'timer', 'av_timer', 'more_time', 'update', 'history', 'restore', 'backspace',
  'clear', 'undo', 'redo', 'content_copy', 'content_cut', 'content_paste', 'link',
  'link_off', 'bug_report', 'code', 'horizontal_rule', 'layers', 'layers_clear',
  'local_parking', 'local_printshop', 'loyalty', 'margin', 'opacity', 'radio_button_checked',
  'radio_button_unchecked', 'remove', 'reply', 'report', 'report_problem', 'save_alt',
  'send', 'smart_button', 'sort_by_alpha', 'source', 'space_bar', 'spellcheck',
  'stars', 'text_fields', 'vertical_align_bottom', 'vertical_align_center', 'vertical_align_top',
  'view_in_ar', 'zoom_in', 'zoom_out', 'add_box', 'add_shopping_cart', 'alarm_add',
  'analytics', 'autorenew', 'backup', 'bed', 'bookmark_add', 'cake', 'call', 'campaign',
  'cancel_presentation', 'car_rental', 'celebration', 'cleaning_services', 'copy_all',
  'coronavirus', 'delivery_dining', 'domain', 'eco', 'electrical_services', 'face',
  'fastfood', 'flag', 'flash_on', 'flash_off', 'flight_class', 'fullscreen',
  'fullscreen_exit', 'gavel', 'gesture', 'gif', 'group_add', 'highlight', 'highlight_off',
  'home_work', 'how_to_reg', 'how_to_vote', 'hvac', 'image_search', 'important_devices',
  'indeterminate_check_box', 'integration_instructions', 'inventory', 'key', 'keyboard_hide',
  'kitchen', 'language', 'leaderboard', 'lens', 'local_activity', 'local_atm',
  'local_dining', 'local_fire_department', 'local_florist', 'local_gas_station', 'local_grocery_store',
  'local_laundry_service', 'local_library', 'local_mall', 'local_movies', 'local_play',
  'local_post_office', 'local_see', 'local_taxi', 'location_city', 'location_disabled',
  'luggage', 'lunch_dining', 'lunch_dining', 'mail_outline', 'mark_email_read', 'mark_email_unread',
  'medical_services', 'mediation', 'meeting_room', 'menu_book', 'miscellaneous_services',
  'model_training', 'monetization_on', 'money', 'monitor', 'mood_bad', 'night_shelter',
  'nights_stay', 'no_luggage', 'no_meals', 'no_meeting_room', 'no_photography',
  'not_interested', 'offline_bolt', 'offline_pin', 'ondemand_video', 'online_prediction',
  'outlet', 'pages', 'pan_tool', 'pause_presentation', 'pending', 'pending_actions',
  'perm_camera_mic', 'perm_contact_calendar', 'perm_data_setting', 'perm_device_information',
  'perm_identity', 'perm_media', 'perm_phone_msg', 'perm_scan_wifi', 'pets', 'photo_album',
  'photo_size_select_actual', 'photo_size_select_large', 'photo_size_select_small', 'piano',
  'picture_as_pdf', 'picture_in_picture', 'picture_in_picture_alt', 'pie_chart_outline',
  'pin_drop', 'plagiarism', 'policy', 'poll', 'polymer', 'pool', 'portable_wifi_off',
  'post_add', 'power', 'power_off', 'pregnant_woman', 'present_to_all', 'preview',
  'priority_high', 'privacy_tip', 'psychology', 'public', 'publish', 'push_pin',
  'qr_code', 'query_builder', 'question_answer', 'quickreply', 'rate_review', 'read_more',
  'record_voice_over', 'remove_red_eye', 'repeat', 'repeat_one', 'replay', 'request_page',
  'request_quote', 'restaurant_menu', 'restore_page', 'ring_volume', 'room', 'room_service',
  'rotate_90_degrees_ccw', 'rounded_corner', 'rowing', 'rule', 'running_with_errors',
  'sanitizer', 'satellite', 'saved_search', 'savings', 'scanner', 'scatter_plot',
  'school', 'science', 'score', 'screen_lock_landscape', 'screen_lock_portrait', 'screen_rotation',
  'screen_share', 'sd_card', 'sd_storage', 'search_off', 'self_improvement', 'sensors',
  'set_meal', 'settings_applications', 'settings_backup_restore', 'settings_bluetooth',
  'settings_brightness', 'settings_cell', 'settings_ethernet', 'settings_input_antenna',
  'settings_input_component', 'settings_input_composite', 'settings_input_hdmi', 'settings_input_svideo',
  'settings_overscan', 'settings_phone', 'settings_power', 'settings_remote', 'settings_voice',
  'shop', 'shop_two', 'shopping_cart_checkout', 'short_text', 'shuffle', 'signal_cellular_alt',
  'sim_card', 'smartphone', 'smoke_free', 'smoking_rooms', 'sms_failed', 'snippet_folder',
  'snooze', 'soap', 'sports', 'sports_baseball', 'sports_basketball', 'sports_cricket',
  'sports_esports', 'sports_football', 'sports_golf', 'sports_handball', 'sports_hockey',
  'sports_kabaddi', 'sports_mma', 'sports_motorsports', 'sports_rugby', 'sports_soccer',
  'sports_tennis', 'sports_volleyball', 'square_foot', 'stacked_bar_chart', 'stay_current_landscape',
  'stay_current_portrait', 'sticky_note_2', 'stop_circle', 'stop_screen_share', 'storage',
  'store_mall_directory', 'straight', 'straighten', 'stream', 'streetview', 'strikethrough_s',
  'subscriptions', 'subtitles', 'subway', 'superscript', 'supervised_user_circle', 'support',
  'surround_sound', 'switch_camera', 'switch_video', 'sync_alt', 'sync_disabled', 'sync_problem',
  'system_update', 'system_update_alt', 'tab', 'tab_unselected', 'table_rows', 'table_view',
  'tablet_android', 'tablet_mac', 'tag_faces', 'takeout_dining', 'tap_and_play', 'text_format',
  'text_rotate_up', 'text_rotate_vertical', 'text_rotation_angledown', 'text_rotation_angleup',
  'text_rotation_down', 'text_rotation_none', 'theaters', 'thumb_down_alt', 'thumb_up_alt',
  'thumbs_up_down', 'title', 'toc', 'toll', 'touch_app', 'tour', 'toys', 'track_changes',
  'traffic', 'transfer_within_a_station', 'translate', 'travel_explore', 'trending_flat',
  'trip_origin', 'tty', 'turned_in', 'Two_wheeler', 'unfold_more', 'unpublished',
  'unsubscribe', 'usb', 'verified', 'vertical_split', 'vibration', 'video_call', 'video_label',
  'video_settings', 'videocam_off', 'view_agenda', 'view_comfy', 'view_compact', 'view_day',
  'view_headline', 'view_sidebar', 'view_stream', 'view_week', 'vignette', 'voice_chat',
  'voice_over_off', 'voicemail', 'vpn_lock', 'wallpaper', 'warning_amber', 'wash',
  'wheelchair_pickup', 'wifi_calling', 'wifi_lock', 'wifi_off', 'wifi_protected_setup',
  'wifi_tethering', 'wine_bar', 'work_off', 'wrap_text', 'wrong_location', 'wysiwyg',
  'youtube_searched_for', 'zoom_out_map',
];

export function getMaterialIconsList(): MaterialIconConfig[] {
  if (icons.length) {
    return icons;
  }

  MATERIAL_ICONS.forEach(name => {
    icons.push({
      name,
      variants: ['filled', 'outlined', 'rounded', 'sharp', 'two-tone'],
    });
  });

  return icons;
}

